import { render, staticRenderFns } from "./Tabset.vue?vue&type=template&id=0a90ed18&scoped=true"
import script from "./Tabset.vue?vue&type=script&lang=js"
export * from "./Tabset.vue?vue&type=script&lang=js"
import style0 from "./Tabset.vue?vue&type=style&index=0&id=0a90ed18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a90ed18",
  null
  
)

export default component.exports